import { ValidationError } from "@p0security/shared/types/error";

const SERVER_ID_PATTERN = /^[a-zA-Z0-9-]+$/;

/** Construct the full MCP server URL from a gateway base URL and server ID. */
export const mcpServerUrl = (gatewayUrl: string, serverId: string): string =>
  new URL(`/mcps/${encodeURIComponent(serverId)}`, gatewayUrl).href;

/** Appends `path` to a gateway base URL, keeping any path prefix on it. */
export const gatewayPathUrl = (gatewayUrl: string, path: string): string =>
  `${gatewayUrl.replace(/\/+$/, "")}/${path}`;

/** The gateway's management API base URL. */
export const gatewayManageUrl = (gatewayUrl: string): string =>
  gatewayPathUrl(gatewayUrl, "manage");

/**
 * Validate that a server path/ID contains only safe characters.
 * Throws ValidationError for path traversal, slashes, or non-alphanumeric characters.
 */
export const validateServerId = (id: string): void => {
  if (!SERVER_ID_PATTERN.test(id)) {
    throw new ValidationError(
      "path",
      { id },
      "Server ID must contain only letters, digits, and hyphens"
    );
  }
};
